import { Trans, useTranslation } from 'react-i18next';

import { appService } from 'services';

const MaintenancePage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-8 p-4">
      <img
        src={appService.loadBrandImage('logo')}
        alt={t('images.logoAlt')}
        width="200"
        height="100"
        className="my-12"
      />
      <h1 className="h1 text-center uppercase font-semibold">{t('maintenance.title')}</h1>
      <img src={appService.loadBrandImage('emptyResults')} alt="" width="495" height="309" />

      <div className="text-center">
        <p className="mb-4">{t('maintenance.content', { brand: appService.brand() })}</p>
        <Trans i18nKey="help">
          <a href="tel:0144064545" className="underline hover:no-underline">
            01 44 06 45 45
          </a>
        </Trans>
      </div>
    </div>
  );
};

export default MaintenancePage;
